import { ERROR_REDUCER, ERROR_SCREENS } from './reducer';

export const selectErrorData = (state) =>
  state[ERROR_REDUCER][ERROR_SCREENS.PROPERTY_ADDRESS_PROPS];
